import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const gaps = [
  { territory: 'Northern Luzon', potential: '₱12.4M', actual: '₱7.8M', gap: '₱4.6M', gapPct: 37, accounts: 142, covered: 89, recommendation: 'Assign 2 additional TSRs to Ilocos Norte & Sur' },
  { territory: 'Eastern Visayas', potential: '₱8.9M', actual: '₱5.1M', gap: '₱3.8M', gapPct: 43, accounts: 98, covered: 54, recommendation: 'Expand distributor network in Leyte & Samar' },
  { territory: 'CARAGA Region', potential: '₱6.2M', actual: '₱3.9M', gap: '₱2.3M', gapPct: 37, accounts: 76, covered: 47, recommendation: 'Activate dormant accounts in Butuan City' },
  { territory: 'BARMM', potential: '₱5.8M', actual: '₱2.9M', gap: '₱2.9M', gapPct: 50, accounts: 64, covered: 31, recommendation: 'Partner with local distributors for market entry' },
];

export default function CoverageGapPanel({ onNavigate }) {
  return (
    <div className="card p-4 lg:p-6 table-panel-depth">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div>
          <h3 className="font-heading font-semibold text-base lg:text-lg text-foreground">Coverage Gap Analysis</h3>
          <p className="font-caption text-xs text-muted-foreground mt-0.5">Territory potential vs actual performance</p>
        </div>
        <Button variant="outline" size="sm" iconName="Map" iconPosition="left" iconSize={14} onClick={() => onNavigate('/philippine-map-visualization')}>
          View Map
        </Button>
      </div>
      <div className="space-y-3">
        {gaps?.map((g) => (
          <div key={g?.territory} className="border border-border rounded-lg p-4 hover:bg-muted transition-colors duration-150">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <h4 className="font-caption text-sm font-semibold text-foreground">{g?.territory}</h4>
                  <span className="px-2 py-0.5 bg-destructive text-destructive-foreground rounded-full font-caption text-xs font-medium">
                    -{g?.gapPct}% gap
                  </span>
                </div>
                <div className="grid grid-cols-3 gap-3 mb-3">
                  <div>
                    <p className="font-caption text-xs text-muted-foreground">Potential</p>
                    <p className="font-data text-sm font-semibold text-foreground">{g?.potential}</p>
                  </div>
                  <div>
                    <p className="font-caption text-xs text-muted-foreground">Actual</p>
                    <p className="font-data text-sm font-semibold text-success">{g?.actual}</p>
                  </div>
                  <div>
                    <p className="font-caption text-xs text-muted-foreground">Gap</p>
                    <p className="font-data text-sm font-semibold text-destructive">{g?.gap}</p>
                  </div>
                </div>
                <div className="mb-2">
                  <div className="flex items-center justify-between mb-1">
                    <span className="font-caption text-xs text-muted-foreground">Account Coverage</span>
                    <span className="font-data text-xs text-foreground">{g?.covered}/{g?.accounts}</span>
                  </div>
                  <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                    <div className="h-full bg-primary rounded-full" style={{ width: `${(g?.covered / g?.accounts) * 100}%` }} />
                  </div>
                </div>
                <div className="flex items-start gap-2 bg-muted rounded-md p-2">
                  <Icon name="Lightbulb" size={13} color="var(--color-accent)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
                  <p className="font-caption text-xs text-muted-foreground">{g?.recommendation}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}